/** Статуси даних у порядку показу (глосарій ТЗ). */
export const DATA_STATUSES = [
    {
        code: 'DEFAULT',
        value: 'Типове значення',
        tone: 'neutral',
        needsReview: false,
        description: 'Значення, запропоноване розробником (класифікатори, правила, профілі ваг, вимоги, календар); Замовник перевіряє й за потреби змінює',
    },
    {
        code: 'OPEN',
        value: 'Відкриті дані',
        tone: 'info',
        needsReview: false,
        description: 'Сформовано з офіційних відкритих джерел Замовника (сайт, опубліковані розклади, графік освітнього процесу)',
    },
    {
        code: 'CHECK',
        value: 'Уточнити',
        tone: 'warning',
        needsReview: true,
        description: 'Дані неповні або суперечливі й потребують підтвердження Замовника',
    },
    {
        code: 'CALC',
        value: 'Розрахунок',
        tone: 'info',
        needsReview: false,
        description: 'Обчислено системою або сервісом (координати, маршрути, формули)',
    },
    {
        code: 'CUSTOMER',
        value: 'Дані Замовника',
        tone: 'success',
        needsReview: false,
        description: 'Дані надано або підтверджено Замовником',
    },
    {
        code: 'CUSTOMER_FILLS',
        value: 'Заповнює Замовник',
        tone: 'neutral',
        needsReview: false,
        description: 'Шаблон або значення, яке має заповнити Замовник',
    },
];
/** Допустимі значення meta.status. */
export const DATA_STATUS_VALUES = DATA_STATUSES.map((s) => s.value);
/** Значення статусів, що потребують уточнення. */
export const NEEDS_REVIEW_STATUSES = DATA_STATUSES.filter((s) => s.needsReview).map((s) => s.value);
const key = (s) => s.trim().replace(/\s+/g, ' ').toLocaleLowerCase('uk-UA');
const BY_KEY = new Map(DATA_STATUSES.flatMap((s) => [
    [key(s.value), s.value],
    [key(s.code), s.value],
]));
/**
 * Чинне значення статусу даних: без урахування регістру й зайвих пробілів або код статусу (OPEN, CHECK …) → значення
 * глосарію. null — невідомий статус (D47: жодних значень конкретного ЗВО; разова конвертація старих файлів закладу — у його
 * пакеті даних, напр. tools/<заклад>).
 */
export function normalizeDataStatus(raw) {
    return BY_KEY.get(key(raw)) ?? null;
}
/** Опис статусу за значенням meta.status (або кодом статусу). */
export function dataStatusDef(value) {
    if (!value)
        return undefined;
    const v = normalizeDataStatus(value);
    return v ? DATA_STATUSES.find((s) => s.value === v) : undefined;
}
/** Чи потребує запис уточнення за значенням meta.status. */
export function needsReview(value) {
    return dataStatusDef(value)?.needsReview === true;
}
//# sourceMappingURL=data-status.js.map